import { synth } from "../game/sfx";

/**
 * پشتِ‌هم: هر فلشی که زودتر از STREAK_MS بعد از فلشِ قبلی بیرون برود، ووش را یک پله بالاتر می‌برد و از پله‌ی دوم
 * یک نتِ زخمه‌ای هم رویش می‌آید که هر بار یکی بالاتر است. لمسِ اشتباه یا مکث از نو. تند بودنت را می‌شنوی، بی هیچ نوشته‌ای.
 */
export const STREAK_MS = 1100;
const TOP = 8;

export interface Streak { n: number; at: number }

export const newStreak = (): Streak => ({ n: 0, at: -Infinity });

/** صدای فلشِ بیرون‌رفته با پله‌ی پشتِ‌هم؛ پله‌ی تازه را برمی‌گرداند. */
export function outSound(s: Streak, now = performance.now()): number {
  s.n = now - s.at < STREAK_MS ? s.n + 1 : 0;
  s.at = now;
  const step = Math.min(s.n, TOP);
  synth("whoosh", { volume: 0.55, pitch: 1 + 0.07 * step });
  if (s.n >= 2) synth("pluck", { step: step - 2 });
  return s.n;
}

/** لمسِ اشتباه پشتِ‌هم را می‌بُرد. */
export function breakStreak(s: Streak): void {
  s.n = 0;
  s.at = -Infinity;
}
